import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m21 21-4.34-4.34" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_date_field = _resolveComponent("bs-date-field")!
  const _component_bs_field = _resolveComponent("bs-field")!
  const _component_bs_select = _resolveComponent("bs-select")!
  const _component_bs_filters_container = _resolveComponent("bs-filters-container")!

  return (_openBlock(), _createBlock(_component_bs_filters_container, {
    class: "waybills-filters",
    onSubmit: _ctx.onSubmit,
    onReset: _ctx.onReset
  }, {
    default: _withCtx(() => [
      _createVNode(_component_bs_date_field, {
        placeholder: "Дата от",
        modelValue: _ctx.state.dateFrom,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.dateFrom) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_bs_date_field, {
        placeholder: "Дата до",
        modelValue: _ctx.state.dateTo,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dateTo) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_bs_field, {
        placeholder: "Номер путевого",
        modelValue: _ctx.state.codeOneC,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codeOneC) = $event)),
        disabled: _ctx.loading
      }, {
        "icon-left": _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_bs_select, {
        placeholder: "Перевозчик",
        "can-deselect": "",
        modelValue: _ctx.state.companyId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.companyId) = $event)),
        searchable: true,
        disabled: _ctx.loading,
        loading: _ctx.data_state.carriers.isLoading,
        failed: _ctx.data_state.carriers.isFailed,
        options: _ctx.data_state.carriers.list,
        onRefresh: _ctx.loadCarriers
      }, null, 8, ["modelValue", "disabled", "loading", "failed", "options", "onRefresh"]),
      _createVNode(_component_bs_select, {
        placeholder: "Водитель",
        "can-deselect": "",
        modelValue: _ctx.state.courierId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.courierId) = $event)),
        "display-by": "fullName",
        "search-by": "fullName",
        searchable: true,
        disabled: _ctx.loading,
        loading: _ctx.data_state.couriers.isLoading,
        failed: _ctx.data_state.couriers.isFailed,
        options: _ctx.data_state.couriers.list,
        onRefresh: _ctx.loadCouriers
      }, null, 8, ["modelValue", "disabled", "loading", "failed", "options", "onRefresh"]),
      _createVNode(_component_bs_select, {
        placeholder: "Статус",
        "can-deselect": "",
        options: _ctx.STATUSES,
        disabled: _ctx.loading,
        modelValue: _ctx.state.statusId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.statusId) = $event))
      }, null, 8, ["options", "disabled", "modelValue"]),
      _createVNode(_component_bs_select, {
        placeholder: "Способ оплаты",
        "can-deselect": "",
        options: _ctx.PAYMENT_TYPES,
        disabled: _ctx.loading,
        modelValue: _ctx.state.paymentTypeId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.paymentTypeId) = $event))
      }, null, 8, ["options", "disabled", "modelValue"]),
      _createVNode(_component_bs_select, {
        placeholder: "Тип перевозки",
        "can-deselect": "",
        options: _ctx.TYPES,
        disabled: _ctx.loading,
        modelValue: _ctx.state.waybillTypeId,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.waybillTypeId) = $event))
      }, null, 8, ["options", "disabled", "modelValue"]),
      _createVNode(_component_bs_select, {
        placeholder: "Город",
        "can-deselect": "",
        modelValue: _ctx.state.cityId,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.cityId) = $event)),
        searchable: true,
        disabled: _ctx.loading,
        loading: _ctx.data_state.cities.isLoading,
        failed: _ctx.data_state.cities.isFailed,
        options: _ctx.data_state.cities.list,
        onRefresh: _ctx.loadCities
      }, null, 8, ["modelValue", "disabled", "loading", "failed", "options", "onRefresh"])
    ]),
    _: 1
  }, 8, ["onSubmit", "onReset"]))
}